import { NsoftProvider } from "./nsoft.provider";
import { EvolutionProvider } from "./evolution.provider";
import { BetgamesProvider } from "./betgames.provider";
import { HabaneroProvider } from "./habanero.provider";
import { StandardGame } from "./standard.provider";
import { PragmaticProvider } from "./pragmatic.provider";
import { LeapProvider } from "./leap.provider";
import { GoldenraceProvider } from "./goldenrace.provider";
import { GlobalbetProvider } from "./globalbet.provider";
import { KironProvider } from "./kiron.provider";
import { BitvilleProvider } from "./bitville.provider";
import { BetradarProvider } from "./betradar.provider";
import { TwainsportsProvider } from "./twainsports.provider";
export function providers({ provider, launchData, user, elementId }) {
    const prov = {
        nsoft: new NsoftProvider({ launchData, user, elementId }),
        Evolution: new EvolutionProvider({ launchData, user, elementId }),
        BetGames: new BetgamesProvider({ launchData, user, elementId }),
        BetGamesNew: new BetgamesProvider({ launchData, user, elementId }),
        Habanero: new HabaneroProvider({ launchData, user, elementId }),
        StandardGame: new StandardGame({ launchData, user, elementId }),
        Pragmatic: new PragmaticProvider({ launchData, user, elementId }),
        Leap: new LeapProvider({ launchData, user, elementId }),
        GoldenRace: new GoldenraceProvider({ launchData, user, elementId }),
        GlobalBet: new GlobalbetProvider({ launchData, user, elementId }),
        Kiron: new KironProvider({ launchData, user, elementId }),
        Bitville: new BitvilleProvider({ launchData, user, elementId }),
        BetRadar: new BetradarProvider({ launchData, user, elementId }),
        TwainSports: new TwainsportsProvider({ launchData, user, elementId }),
    };
    console.log({ provider, launchData, user, elementId });
    const providerSelector = prov[provider || "StandardGame"];
    return providerSelector.init();
}
